export default __webpack_public_path__ + "static/img5-09dbf6240bb112510118a2f30c024c37.png";